//@flow
import React, { Component } from 'react'
import { connect } from 'react-redux'

import Tooltip from '../Controls/Tooltip'
import OpinaryToggle from '../Controls/OpinaryToggle'
import VerticalTargeting from './VerticalTargeting'

import { selectCurrentUser } from '../../stores/currentUser'
import { hasAutomationPermissions } from '../../stores/usersStore'
import { selectCheckedoutPoll } from '../../stores/pollBuilderCheckedoutPoll'
import { fetchCustomerVerticals } from '../../stores/customersStore'
import type { Dispatch } from '../../types'

type Props = {
  poll: Object,
  isAdmin: boolean,
  checkedoutPoll: any,
  horizontal: boolean,
  toggleAttribute: Function,
  fetchCustomerVerticals: Function,
  hasAutomationPermissions: boolean,
  canAddToLib: boolean,
}

type State = {
  displayTooltip: boolean,
}

class PollFormToggles extends Component<Props, State> {
  state = {
    displayTooltip: false,
  }

  componentDidMount() {
    this.fetchCustomerVerticals()
  }

  componentDidUpdate(prevProps: Object) {
    const { poll, toggleAttribute, checkedoutPoll } = this.props

    // if poll is of type ranking and answers are 6+, horizontal mode is enabled - display an info tooltip for the user regarding this change
    if (
      checkedoutPoll.kind === 'ranking' &&
      poll.options.length !== prevProps.poll.options.length
    ) {
      if (poll.options.length > 5) {
        this.setState({ displayTooltip: true })
        toggleAttribute('horizontal', true)

        setTimeout(() => this.setState({ displayTooltip: false }), 9000)
      }
    }

    if (poll.customer !== prevProps.poll.customer) this.fetchCustomerVerticals()
  }

  fetchCustomerVerticals = () => {
    this.props.fetchCustomerVerticals(this.props.poll.customer)
  }

  render() {
    const {
      poll,
      toggleAttribute,
      isAdmin,
      hasAutomationPermissions,
      canAddToLib,
    } = this.props

    const { displayTooltip } = this.state

    return (
      <div className="flex flex-column ml-auto">
        {canAddToLib && (
          <div className="mb3">
            <OpinaryToggle
              className="mb3"
              toggled={poll.addToAutomationLibrary}
              label="Automation"
              onChange={val => toggleAttribute('addToAutomationLibrary', val)}
            />
            <VerticalTargeting
              onChange={val => toggleAttribute('verticals', val)}
            />
          </div>
        )}

        {hasAutomationPermissions && !canAddToLib && (
          <div>
            <div className="mb3">
              <span className="gray mr3" style={{ verticalAlign: 'super' }}>
                Automated?
              </span>
              {poll.automationConfigured ? (
                <span
                  className="f6 bg-op-brand fr white h2"
                  style={{ padding: '5px 28px' }}
                >
                  Automated
                </span>
              ) : (
                <span
                  className="f6 bg-gray fr white h2"
                  style={{ padding: '5px 15px' }}
                >
                  Not Automated
                </span>
              )}
            </div>
            <OpinaryToggle
              className="mb3"
              toggled={poll.automationSuggested}
              label="Recommend for automation"
              onChange={val => toggleAttribute('automationSuggested', val)}
            />
          </div>
        )}

        {isAdmin === true && (
          <div className="flex flex-column ml-auto">
            <OpinaryToggle
              className="mb3"
              toggled={poll.sponsored}
              label="Sponsored?"
              onChange={val => toggleAttribute('sponsored', val)}
            />
            <OpinaryToggle
              className="mb3"
              toggled={poll.adminOnlyEdit}
              label="Admin-Only Edit?"
              onChange={val => toggleAttribute('adminOnlyEdit', val)}
            />
          </div>
        )}

        {poll.kind === 'ranking' && (
          <div>
            <div className="mb-small relative">
              {displayTooltip && (
                <Tooltip
                  show={true}
                  colorClass="white"
                  arrowClass="op-brand"
                  backgroundClass={'op-background'}
                  arrowDown={true}
                  arrowUp={false}
                  styles={{ bottom: 0 }}
                >
                  Horizontal mode has been enabled. This is optimal for polls
                  with 6+ answers. <br /> You can switch this if you want!
                </Tooltip>
              )}
            </div>

            <OpinaryToggle
              toggled={poll.horizontal}
              label="Horizontal Mode?"
              onChange={val => toggleAttribute('horizontal', val)}
            />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  // Check if user exist to check automation permissions
  const user = selectCurrentUser(state)
  return {
    checkedoutPoll: selectCheckedoutPoll(state),
    hasAutomationPermissions: user ? hasAutomationPermissions(user) : false,
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchCustomerVerticals(id) {
    dispatch(fetchCustomerVerticals(id))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PollFormToggles)



// WEBPACK FOOTER //
// ./src/components/PollForm/PollFormToggles.js